import FilterModal from "src/components/common/FilterFrame/FilterModal";
import type { FilterFieldConfig } from "src/components/common/FilterFrame/FilterModal";

export const fields: FilterFieldConfig[] = [
    { key: "name", label: "Lead Name", type: "text", default: "" },
    { key: "organizationId", label: "Organization", type: "asyncSelect", default: "",
        fileName: "common/searchOrganization.php",
        placeholder: "Search organization…",
        isMulti: false,
    },
    { key: "role", label: "Role", type: "text", default: "" },
    { key: "businessPhone", label: "Business Number", type: "text", default: "" },
    { key: "extension", label: "Extension", type: "text", default: "" },
    { key: "fax", label: "Fax",  type: "text", default: "" },
    { key: "mobile", label: "Mobile Number", type: "text", default: "" },
    { key: "email", label: "Email", type: "text", default: "" },
    { key: "address", label: "Address", type: "text", default: "" },
    { key: "overseaAddress", label: "Oversea Address", type: "text", default: "" },


    
    { key: "website", label: "Website", type: "text", default: "" },
    { key: "industry", label: "Industry", type: "text", default: "" },
    { key: "source", label: "Source", type: "select", default: "", options: [
        "Outreach",
        "Patrner Referral",
        "Phone Enquiry",
        "Web",
        "Others"
    ].map(v => ({value: v, label: v}))},
    { key: "status", label: "Status", type: "select", default: "", options: [
        "Not Contacted",
        "Contacted",
        "Converted",
        "Disqualified"
    ].map(v => ({value: v, label: v}))},
    { key: "userResponsible1", label: "userResponsible 1", type: "text", default: "" },
    { key: "userResponsible2", label: "userResponsible 2", type: "text", default: "" },
    { key: "referredBy", label: "Referred By", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },



    { key: "background", label: "Background", type: "text", default: "" },
    { key: "creatorId", label: "Created By", type: "asyncSelect", default: "",
        fileName: "common/searchUser.php",
        placeholder: "Search user…",
        isMulti: false,
    },
    { key: "createdAt", label: "Created At", type: "range", default: "", inputType: "date" },
    { key: "updaterId", label: "Updated By", type: "asyncSelect", default: "", 
        fileName: "common/searchUser.php", 
        placeholder: "Search user…", 
        isMulti: false, 
    },
    { key: "updatedAt", label: "Updated At", type: "range", default: "", inputType: "date" },
    { key: "void", label: "Validity", type: "select", default: "no",
        options: [
        { value: "no", label: "Valid" },
        { value: "yes", label: "Void" },
        { value: "all", label: "All" },
        ],
    },
    { key: "voidReason", label: "Void Reason", type: "text", default: "" },
    { key: "validateReason", label: "Validate Reason", type: "text", default: "" },
];

export default function LeadFilterForm() {
    return <FilterModal title="Filter" width={650} fields={fields} />;
}
